(function(){
    function sortBy(table, colIndex, dir){
        const tbody = table.tBodies[0];
        const rows = Array.from(tbody.rows);
        const get = r => (r.cells[colIndex]?.dataset.value ?? r.cells[colIndex].textContent).trim().toLowerCase();
        rows.sort((a,b)=>{
            const A = get(a), B = get(b);
            const nA = +A, nB = +B;
            const v = (isFinite(nA) && isFinite(nB)) ? (nA - nB) : A.localeCompare(B);
            return dir === 'desc' ? -v : v;
        });
        rows.forEach(r=>tbody.appendChild(r));
    }

    document.querySelectorAll('table.table').forEach(table=>{
        table.querySelectorAll('thead th[data-sort]').forEach((th, i)=>{
            th.addEventListener('click', ()=>{
                const current = th.getAttribute('data-order') === '▲' ? 'asc' : th.getAttribute('data-order') === '▼' ? 'desc' : null;
                const next = current === 'asc' ? 'desc' : 'asc';
                table.querySelectorAll('thead th[data-sort]').forEach(t => t.setAttribute('data-order',''));
                th.setAttribute('data-order', next === 'asc' ? '▲' : '▼');
                sortBy(table, i, next);
            });
        });
    });
})();
